// extracted by mini-css-extract-plugin
export default {"blobb_svg":"MyBlobbSVG_blobb_svg__wpQvS","blobb_svg_w_stats":"MyBlobbSVG_blobb_svg_w_stats__aQ0cO","pop-in":"MyBlobbSVG_pop-in__Rtttt"};